<template>
  <div
    class="base-icon"
    v-html="require(`!html-loader!@/assets/icons/${name}.svg`)"
  ></div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss">
// div > svg > g > path {
//   stroke: currentColor !important;
// }

div > svg > path {
  stroke: currentColor !important;
}

// svg > path {
//   stroke: currentColor !important;
// }
</style>
